import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const getCities = createAsyncThunk(
  'locations/getCities',
  catchAsync(async () => {
    const res = await axios.get(`${process.env.PUBLIC_URL}/assets/data/cities.json`, {
      baseURL: '', // Перевизначаємо baseURL для цього запиту
    });
    return res.data;
  })
);
